import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "menu-item-grandchild"
}
const _hoisted_3 = ["onClick"]

import UseMainNavigation from "./UseMainNavigation";
import ExpandMoreIcon from "../Modules/Icons/ExpandMoreIcon.vue";
import ExpandLessIcon from "../Modules/Icons/ExpandLessIcon.vue";
import { TGetAvailablePrograms } from "../Modules/State/Typings/SingleViewStoreTypes";

export interface IElementConfig {
  hasDropdown?: boolean;
  hasTag?: boolean;
  tagColor?: string;
  tagText?: string;
  hasIcon?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    label: null,
    to: null,
    activeProgram: null,
    config: null,
    navChildren: null
  },
  setup(__props: any) {

const props = __props as {
  label?: string;
  to?: string;
  activeProgram?: string;
  config?: IElementConfig;
  navChildren?: {
    label?: string;
    to?: string;
    config?: IElementConfig;
    isLink?: boolean;
    getAvailablePrograms?: TGetAvailablePrograms[];
  }[];
}



const { handleDropDownClick, markDropDownActive, programHandler } =
  UseMainNavigation();

return (_ctx: any,_cache: any) => {
  const _component_sv_badge = _resolveComponent("sv-badge")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!props.config?.hasDropdown)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "menu-item",
          to: props.to
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(props.label), 1),
            (props.config?.hasTag)
              ? (_openBlock(), _createBlock(_component_sv_badge, {
                  key: 0,
                  color: props.config?.tagColor
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.config?.tagText), 1)
                  ]),
                  _: 1
                }, 8, ["color"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["menu-item", { active: _unref(markDropDownActive) }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleDropDownClick) && _unref(handleDropDownClick)(...args)))
        }, [
          _createTextVNode(_toDisplayString(props.label) + " ", 1),
          (props.config?.hasTag)
            ? (_openBlock(), _createBlock(_component_sv_badge, {
                key: 0,
                color: props.config?.tagColor
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.config?.tagText), 1)
                ]),
                _: 1
              }, 8, ["color"]))
            : (props.config?.hasIcon)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  (!_unref(markDropDownActive))
                    ? (_openBlock(), _createBlock(ExpandMoreIcon, { key: 0 }))
                    : (_openBlock(), _createBlock(ExpandLessIcon, { key: 1 }))
                ]))
              : _createCommentVNode("", true)
        ], 2)),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_unref(markDropDownActive))
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (props.navChildren?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.navChildren, (child, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                      (child?.isLink)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: child?.to
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(child?.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (child?.getAvailablePrograms?.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(child?.getAvailablePrograms, (heading) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: _normalizeClass(["menu-item", { active: heading.programcode === props.activeProgram }]),
                                key: heading?.program_name,
                                onClick: 
            () => _unref(programHandler)(heading?.programcode, heading?.program_name)
          
                              }, [
                                _createTextVNode(_toDisplayString(heading?.program_name) + " ", 1),
                                (props.config?.hasTag)
                                  ? (_openBlock(), _createBlock(_component_sv_badge, {
                                      key: 0,
                                      color: props.config?.tagColor
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.config?.tagText), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["color"]))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_3))
                            }), 128))
                          : _createCommentVNode("", true)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})